module.exports = __webpack_public_path__ + "media/images/icon/white/ico_angle_right-59fc8b67ac354e37cb026582b1ff8fcb.svg";